<div class="row">
  <div
    class="col"
    baseTruncate
  >
    {{ provider?.customerLocation?.name | baseIsEmpty }}
  </div>

  <div
    class="col d-flex align-items-center"
    baseTruncate
  >
    <base-avatar
      [image]="provider?.logo?.data || undefined"
      [size]="avatarSize.medium"
      [isCompany]="true"
    ></base-avatar>
    <div
      baseTruncate
      class="ms-3"
    >
      <span class="fw-bold">{{ provider?.pspBranchName | baseIsEmpty }}</span
      ><br />
      {{ provider?.pspLegalName | baseIsEmpty }}
    </div>
  </div>

  <div class="col-1">
    <i
      class="fa-solid"
      [class]="provider?.deliveryPriority + ' fa-circle-' + provider?.deliveryPriority"
      [ngbTooltip]="
        ('administration.timeToWait.timeToWaitCategory' | translate) + ' ' + provider?.deliveryPriority.toUpperCase()
      "
    ></i>
  </div>

  <div class="col">
    <p
      class="m-0"
      baseTruncate
    >
      {{ provider?.address.street | baseIsEmpty }}
    </p>
    <p
      class="m-0"
      baseTruncate
    >
      {{ (provider?.address.postCode | baseIsEmpty) + ' ' + (provider?.address.city | baseIsEmpty) }}
    </p>
  </div>

  <div class="col-2">
    <base-izs-rating
      [color]="provider.izsStatus"
      (click)="onIZSInfoOpen($event)"
    ></base-izs-rating>
  </div>
</div>
